/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const OperatorFields = {
    Process: 'PROCESS',
    ReferenceNumber: 'REFERENCE_NUMBER',
    Sequence: 'SEQUENCE',
    State: 'STATE',
    ImoClasses: 'IMO_CLASSES',
    Weight: 'WEIGHT',
    Iso: 'ISO',
    Length: 'LENGTH',
    Height: 'HEIGHT',
    Type: 'TYPE',
    Temperature: 'TEMPERATURE',
    Carrier: 'CARRIER',
    Operator: 'OPERATOR',
    Pod: 'POD',
    TransportMode: 'TRANSPORT_MODE',
    Consignee: 'CONSIGNEE',
} as const;

export type OperatorFields = typeof OperatorFields[keyof typeof OperatorFields];



